<template>
    <svg :width="`${size}px`" :height="`${size}px`" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m38.995 6.292-.016-.012v.015L30.935.494c-1.128-.815-2.732-.6-3.582.483L24.96 4.012l-.777-.56c-1.115-.812-2.707-.604-3.555.466l-.012.016c-.168.206-3.691 4.684-4.49 5.698-2.665.198-4.771 2.378-4.771 5.067 0 1.645.799 3.092 2.019 4.025l-7.088 9.008a1.332 1.332 0 0 0 .27 1.906l.9.648L7 40l8.506-3.908.992.715a1.36 1.36 0 0 0 1.86-.259L39.482 9.711c.85-1.073.633-2.604-.486-3.419z"
            fill="#000"
        />
        <path
            ref="fillPathRef"
            :class="fillClass"
            d="m22.811 6.731-16.525 21a1.332 1.332 0 0 0 .27 1.907l9.942 7.17a1.36 1.36 0 0 0 1.86-.26L34.93 15.484 22.811 6.731z"
        />
        <path
            ref="outlinePathRef"
            :class="outlineClass"
            d="M38.995 6.292a.749.749 0 0 0-.016-.012v.015L30.934.494A2.621 2.621 0 0 0 29.396 0c-.775 0-1.541.337-2.044.977L24.96 4.012l-.777-.56a2.598 2.598 0 0 0-1.533-.495c-.766 0-1.523.331-2.022.961-.004.005-.009.01-.012.016-.168.206-3.692 4.684-4.49 5.699-2.665.198-4.772 2.377-4.772 5.066 0 1.466.637 2.772 1.64 3.7l-7.102 9.024c-.311.396-.444.89-.374 1.389s.335.936.746 1.232l1.163.838L7 40l7.984-3.669 1.222.882c.33.238.712.353 1.089.353.55 0 1.092-.244 1.456-.709l16.571-21.063a.496.496 0 0 0-.082-.695l4.241-5.388c.85-1.073.633-2.604-.486-3.419zM8.075 38.405l.32-6.825 5.657 4.08-5.976 2.745zm9.89-2.166a.855.855 0 0 1-1.175.163l-9.942-7.169a.828.828 0 0 1-.34-.561.825.825 0 0 1 .17-.631l16.23-20.623 11.307 8.167-16.25 20.654zm20.73-27.147-4.262 5.417-11.329-8.183a.5.5 0 0 0-.685.096l-8.79 11.17c-.802-.771-1.274-1.792-1.274-2.893 0-2.122 1.689-3.91 3.845-4.07a1 1 0 0 0 .712-.378 3522.01 3522.01 0 0 1 4.5-5.712c.293-.37.744-.582 1.238-.582.345 0 .671.105.949.307l.777.56a.998.998 0 0 0 1.37-.193l2.392-3.036A1.584 1.584 0 0 1 29.396 1c.347 0 .677.106.953.305l8.046 5.8a.99.99 0 0 0 .097.063 1.4 1.4 0 0 1 .495.885c.05.37-.052.737-.291 1.04z"
        />
    </svg>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { collectionPinProps, useCollectionPinComponent } from 'ihunter-pathfinder-components';
import { CollectionType } from 'ihunter-common';

const props = defineProps({
    ...collectionPinProps(CollectionType.Drawing),
});

const { size, fillClass, outlineClass, initializeStyleFillColor, initializeStyleOutlineColor } = useCollectionPinComponent(props);

const fillPathRef = ref(null);
const outlinePathRef = ref(null);

onMounted(() => {
    initializeStyleFillColor(fillPathRef);
    initializeStyleOutlineColor(outlinePathRef);
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

@include Pathfinder.Pin;
</style>
